import { computed, inject, Injectable, signal } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { fromEvent, merge, of } from 'rxjs';
import { debounceTime, first } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { getDebounceTime } from '@shared/helpers/get-debounce-time';
import { mapResponse } from '@ngrx/operators';

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusService {
  private apollo = inject(Apollo);
  private http = inject(HttpClient);
  readonly networkStatus = signal(navigator.onLine);
  readonly isOffline = computed(() => !this.networkStatus());

  init() {
    merge(fromEvent(window, 'online'), fromEvent(window, 'offline'))
      .pipe(debounceTime(getDebounceTime()))
      .subscribe((event: Event) => {
        if (event.type === 'online') {
          this.verifyConnectivity();
        } else {
          this.networkStatus.set(false);
        }
      });
  }

  verifyConnectivity() {
    this.http
      .get('https://jsonplaceholder.typicode.com/albums/1', {
        headers: { 'Cache-Control': 'no-cache, no-store, must-revalidate' },
      })
      .pipe(
        first(),
        mapResponse({
          next: () => {
            this.networkStatus.set(true);
            if (!this.networkStatus()) {
              this.refreshAllQueries();
            }
            return true;
          },
          error: () => {
            this.networkStatus.set(false);
            return of(false);
          },
        }),
      )
      .subscribe();
  }

  refreshAllQueries() {
    this.apollo.client.refetchQueries({ include: 'active' });
    this.apollo.use('legacy').client.refetchQueries({ include: 'active' });
    this.apollo.use('ecom').client.refetchQueries({ include: 'active' });
  }
}
